var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.stype === 'small')?_c('div',{staticClass:"feature-post d-block cursor-pointer",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"feature-post-thumb",style:({
      backgroundImage: `url(${_vm.datas.coverurl})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    })}),_c('div',{staticClass:"feature-post-content"},[_c('div',{staticClass:"post-meta"}),_c('h4',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.datas.title)+" ")])])]):(_vm.stype === 'big')?_c('div',{staticClass:"single-play-post-item d-block cursor-pointer",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"single-play-post-bg",style:({
      backgroundImage: `url(${_vm.datas.coverurl})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      width: '493px',
      height: '383px'
    })}),_c('div',{staticClass:"single-play-post-content"},[_vm._m(0),_c('h3',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.datas.title)+" ")])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post-meta"},[_c('div',{staticClass:"meta-date"})])
}]

export { render, staticRenderFns }